import { commentsData } from '@/mocks/tanhua';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            爱好者评价
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            来自探花爱好者们的真实反馈，听听他们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {commentsData.map((comment) => (
            <article
              key={comment.id}
              className="p-5 bg-background-50 rounded-lg border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <img
                  src={comment.avatar}
                  alt={comment.user}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <div className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                    {comment.user}
                  </div>
                  <div className="text-xs text-foreground-500">{comment.date}</div>
                </div>
                <div className="ml-auto flex items-center gap-1">
                  {Array.from({ length: comment.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-xs text-accent-500"></i>
                  ))}
                </div>
              </div>
              <p className="text-xs md:text-sm text-foreground-700 leading-relaxed">
                {comment.content}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}